const CreditAgencyEnum = Object.freeze({
    TRANSUNION: "TRANSUNION",
    EXPERIAN: "EXPERIAN",
});
export default CreditAgencyEnum;
